import { IpisUnexpectedError } from "@ipis/client-essentials";
import { ErrorBoundary } from "react-error-boundary";
import { TWorkerSignInData } from "../../../_model/schemas-and-types/repo-schemas";
import withHandymanCredentials from "../../../components/auth/hocs/withWorkerCredentials";
import AppPage from "../../../components/layout/AppPage";

const HandymanAiChatRoute = (_props: TWorkerSignInData) => {

  return (
    <ErrorBoundary
      fallbackRender={(error) => <IpisUnexpectedError error={error} />}
    >
      <AppPage
        headerProps={{
          heading: "Chatt",
        }}
      >
        <iframe
          title="Chatt"
          src="/talkie-chat.html"
          style={{ width: "100%", height: "100%", border: "none" }}
          allow="microphone"
        />
      </AppPage>
    </ErrorBoundary>

  );
};

export default withHandymanCredentials(HandymanAiChatRoute);
